import React from "react";
import LoginComponent from "../../components/login-component";

const Login = () => {
  return (
    <div>
      <LoginComponent />
    </div>
  );
};

export default Login;
